import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useLayoutEffect, useState } from 'react';
import { MainMenuGroup } from '~/components/MainMenu/MainMenuGroup';
import { MainMenuItemError } from '~/components/MainMenu/MainMenuItemError';
import { useAppSelector } from '~/application/hooks';
import { selectIsDrawerOpen } from '~/application/slice';
import type { NavigationItemType } from '~/types/navigation';

import mainMenu from '~/application/main-menu';

export const MainMenu = () => {
    const drawerOpen = useAppSelector(selectIsDrawerOpen);

    const [menuItems, setMenuItems] = useState<NavigationItemType[]>([]);

    useLayoutEffect(() => {
        setMenuItems(mainMenu);
    }, [mainMenu]);

    return (
        <MainMenuRoot open={drawerOpen}>
            {menuItems.map(item =>
                item.type === 'group'
                    ? <MainMenuGroup key={item.id} item={item} />
                    : <MainMenuItemError key={item.id} message="Stavka mora biti tipa 'group'." />
            )}
        </MainMenuRoot>
    );
};

const MainMenuRoot = styled(Box, {
    shouldForwardProp: prop => prop !== 'open',
})<{ open: boolean }>(
    ({ open, theme }) => ({
        paddingTop: open ? theme.spacing(2) : 0,
        '& > ul:first-of-type': { marginTop: 0 },
        display: 'block',
    }),
);

